import { injectIntl, WrappedComponentProps } from 'react-intl';
import { withStyles, WithStyles } from '@material-ui/core/styles';
import {
    Grid,
    Typography,
    Button,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    IconButton,
} from '@material-ui/core';
import CancelPresentation from '@material-ui/icons/CancelPresentation';

import FormInput from 'Console/components/common/form/FormInput';

const styles = (theme) => ({
    root: {
        margin: '42px 48px',
        [theme.breakpoints.between('xs', 'sm')]: {
            margin: '42px 48px',
            display: 'flex',
            'flex-direction': 'column',
        },
    },
    message: {
        paddingBottom: theme.typography.pxToRem(20),
    },
    formInput: {
        width: '35%',
        marginRight: theme.typography.pxToRem(21),
        [theme.breakpoints.between('xs', 'sm')]: {
            width: '100%',
            marginBottom: '5%',
        },
    },
    boxList: {
        width: '44%',
        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },
    },
    listItems: {
        width: '100%',
        paddingTop: theme.typography.pxToRem(20),
    },
    listItem: {
        padding: 0,
    },
});

interface InviteNewUsersProps extends WithStyles<typeof styles>, WrappedComponentProps {
    form: any;
    emails?: string[];
}

const InviteNewUsers = ({
    classes,
    intl,
    form,
    form: { getFieldValue, setFieldsValue, getFieldError, getFieldDecorator },
    emails = [],
}: InviteNewUsersProps) => {
    const handleAddNewUsers = () => {
        const email = getFieldValue('applicationInviteUsers');
        const emails = getFieldValue('inviteEmails');

        if (getFieldError('applicationInviteUsers') || emails.includes(email)) {
            return;
        }

        setFieldsValue({
            inviteEmails: [...emails, email],
            applicationInviteUsers: '',
        });
    };

    const handeRemoveUser = (userToDelete) => {
        const emails = getFieldValue('inviteEmails');

        setFieldsValue({
            inviteEmails: emails.filter((item) => item !== userToDelete),
        });
    };

    getFieldDecorator('inviteEmails', {
        initialValue: emails,
        preserve: true,
    });

    const valueNewUser = getFieldValue('applicationInviteUsers');

    return (
        <>
            <Typography className={classes.message}>
                {intl.formatMessage({ id: 'Applications.createNewApp.message' })}
            </Typography>

            <Grid container direction="row" alignItems="flex-end">
                <Grid id="yeself-invite-new-user" className={classes.formInput}>
                    <FormInput
                        fullWidth={false}
                        form={form}
                        type="email"
                        isRequired={false}
                        validateTrigger="onChange"
                        formItemKey="applicationInviteUsers"
                        placeholder={intl.formatMessage({
                            id: 'Application.createNewApp.placeholder',
                        })}
                        additionalRules={[
                            {
                                type: 'email',
                                message: intl.formatMessage({ id: 'Form.field.email' }),
                            },
                        ]}
                    />
                </Grid>

                <Typography variant="button">
                    <Button
                        id="yeself-button"
                        variant="contained"
                        color="primary"
                        onClick={handleAddNewUsers}
                        disabled={!valueNewUser || getFieldError('applicationInviteUsers')}
                    >
                        {intl.formatMessage({ id: 'Buttons.add' })}
                    </Button>
                </Typography>
            </Grid>

            <Grid container className={classes.boxList}>
                <List className={classes.listItems}>
                    {getFieldValue('inviteEmails') &&
                        getFieldValue('inviteEmails').map((item, index) => (
                            // eslint-disable-next-line react/no-array-index-key
                            <ListItem key={`${item}-${index}`} className={classes.listItem}>
                                <Grid container alignItems="center">
                                    <ListItemText primary={item} />

                                    <ListItemIcon>
                                        <IconButton
                                            aria-label="Delete"
                                            onClick={() => handeRemoveUser(item)}
                                        >
                                            <CancelPresentation />
                                        </IconButton>
                                    </ListItemIcon>
                                </Grid>
                            </ListItem>
                        ))}
                </List>
            </Grid>
        </>
    );
};

export default injectIntl(withStyles(styles)(InviteNewUsers));
